import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import LabShell, { LabNotifyForm } from "@/components/LabShell";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Where Stripe drops people after a monthly or one-time contribution. */
export default function SupportThanks() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!sessionId) {
      setStatus("unknown");
      return undefined;
    }
    let tries = 0;
    let stop = false;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          return;
        }
      } catch (e) {
        /* keep trying */
      }
      tries += 1;
      if (!stop && tries < 8) setTimeout(poll, 2000);
      else if (!stop) setStatus("pending");
    };
    poll();
    return () => {
      stop = true;
    };
  }, [sessionId]);

  return (
    <LabShell>
      <section className="pt-20 pb-24 max-w-[60ch]">
        <p
          className="text-xs uppercase mb-4"
          style={{ color: "#8C8198", fontFamily: "'Courier Prime', monospace", letterSpacing: "0.22em" }}
        >
          {status === "paid" ? "You're in" : "Thank you"}
        </p>
        <h1
          className="text-4xl sm:text-5xl mb-5"
          style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 600 }}
          data-testid="support-thanks-title"
        >
          Thank you for keeping the lab open.
        </h1>
        <p className="text-base mb-4" style={{ color: "#5C5268", lineHeight: 1.8 }}>
          {status === "paid"
            ? "Your contribution went through — Stripe has your receipt. This pays for the hosting and the next experiment on the bench."
            : status === "pending"
            ? "Stripe is still confirming the payment. If you got a receipt, you're all set — it can take a moment to land here."
            : "If you just contributed, Stripe has your receipt."}
        </p>
        <div className="mt-8 mb-10">
          <p className="text-sm mb-3" style={{ color: "#5C5268" }}>
            Want a heads-up when the next experiment opens?
          </p>
          <LabNotifyForm testPrefix="thanks-notify" />
        </div>
        <div className="flex flex-wrap gap-3">
          <Link
            to="/harp"
            className="rounded-full px-6 py-3 text-xs"
            style={{ backgroundColor: "#D99B26", color: "#fff", fontFamily: "'Courier Prime', monospace", letterSpacing: "0.16em" }}
          >
            BACK TO THE HARP
          </Link>
          <Link
            to="/"
            className="rounded-full px-6 py-3 text-xs"
            style={{ border: "1px solid #D6CBB8", color: "#5C5268", fontFamily: "'Courier Prime', monospace", letterSpacing: "0.16em" }}
          >
            THE LAB
          </Link>
        </div>
      </section>
    </LabShell>
  );
}
